var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, Children, cloneElement, createRef } from "react";
import ListingMapStatic from "../listing-map-static/ListingMapStatic";
import HeroSlide from "./HeroSlide";
import HeroSliderPrev from "./HeroSliderPrev";
import HeroSliderNext from "./HeroSliderNext";
import { Container, Slides, Grid, MapContainer } from "./styled/hero-slider";
var HeroSlider = /** @class */ (function (_super) {
    __extends(HeroSlider, _super);
    function HeroSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.containerRef = createRef();
        _this.slidesRef = createRef();
        _this.gridRef = createRef();
        _this.state = {
            imageLoadedCount: 0,
            totalImageCount: Children.toArray(_this.props.children).filter(function (child) {
                var el = child;
                var styledEl = child;
                return el.type === "img" || styledEl.type.target === "img";
            }).length,
            allImagesHaveLoaded: false,
            showPrevButton: false,
            showNextButton: false,
            currentIndex: 0,
            left: 0,
            slideContentIsOverflowingContainer: false,
            totalWidthOfSliderChildren: 0
        };
        _this.handleImgLoad = function () {
            _this.setState({
                imageLoadedCount: _this.state.imageLoadedCount + 1,
                allImagesHaveLoaded: _this.state.imageLoadedCount + 1 === _this.state.totalImageCount
            });
        };
        _this.handleOnMouseUp = function () {
            var _a;
            _this.setState({
                currentIndex: _this.getCurrentIndex(),
                left: Math.round(((_a = _this.slidesRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0)
            });
        };
        _this.handleOnScroll = function () {
            _this.toggleButtons();
        };
        _this.handleOnPrev = function () {
            var _a, _b;
            var currentIndex = _this.state.currentIndex;
            var containerOffsetLeft = ((_a = _this.containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) || 0;
            var domSlides = Array.from(((_b = _this.gridRef.current) === null || _b === void 0 ? void 0 : _b.childNodes) || []);
            var currentDomSlide = domSlides[currentIndex];
            var currentDomSlideLeft = Math.round(currentDomSlide.getBoundingClientRect().left || 0);
            var currentDomSlideRight = Math.round(currentDomSlide.getBoundingClientRect().right || 0);
            var shouldSlideToCurrentDomSlide = currentDomSlideLeft < 0 && currentDomSlideRight > 0;
            var nextDomSlide = currentIndex === 0 || shouldSlideToCurrentDomSlide
                ? currentDomSlide
                : domSlides[currentIndex - 1];
            var nextDomSlideLeft = Math.round(nextDomSlide.getBoundingClientRect().left || 0);
            var domSlider = _this.slidesRef.current;
            var currentLeft = (domSlider === null || domSlider === void 0 ? void 0 : domSlider.scrollLeft) || 0;
            _this.setState({ currentIndex: _this.getCurrentIndex() }, function () {
                _this.scrollSlider({
                    left: Math.round(currentLeft + nextDomSlideLeft - containerOffsetLeft)
                });
            });
        };
        _this.handleOnNext = function () {
            var _a, _b;
            var currentIndex = _this.state.currentIndex;
            var containerOffsetLeft = ((_a = _this.containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) || 0;
            var domSlides = Array.from(((_b = _this.gridRef.current) === null || _b === void 0 ? void 0 : _b.childNodes) || []);
            var nextDomSlide = domSlides[currentIndex + 1];
            var nextDomSlideLeft = Math.round((nextDomSlide === null || nextDomSlide === void 0 ? void 0 : nextDomSlide.getBoundingClientRect().left) || 0);
            var domSlider = _this.slidesRef.current;
            var currentLeft = (domSlider === null || domSlider === void 0 ? void 0 : domSlider.scrollLeft) || 0;
            _this.setState({ currentIndex: _this.getCurrentIndex() }, function () {
                _this.scrollSlider({
                    left: Math.round(currentLeft + nextDomSlideLeft - containerOffsetLeft)
                });
            });
        };
        _this.handleOnKeyDown = function (e) {
            var _a;
            var key = e.key;
            if (!["ArrowLeft", "ArrowRight"].includes(key))
                return;
            _this.setState({
                currentIndex: _this.getCurrentIndex(),
                left: Math.round(((_a = _this.slidesRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0)
            }, function () {
                if (key === "ArrowLeft") {
                    _this.handleOnPrev();
                }
                else if (key === "ArrowRight") {
                    _this.handleOnNext();
                }
            });
        };
        _this.toggleButtons = function () {
            var _a, _b, _c;
            var slideContentIsOverflowingContainer = _this.state.slideContentIsOverflowingContainer;
            var scrollLeft = ((_a = _this.slidesRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0;
            var scrollWidth = ((_b = _this.slidesRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth) || 0;
            var slidesWidth = ((_c = _this.slidesRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width) || 0;
            var showPrevButton = scrollLeft > 0 && slideContentIsOverflowingContainer;
            var showNextButton = (scrollLeft <= 0 || scrollWidth - scrollLeft !== slidesWidth) &&
                slideContentIsOverflowingContainer;
            if (showPrevButton === _this.state.showPrevButton &&
                showNextButton === _this.state.showNextButton) {
                return;
            }
            _this.setState({ showPrevButton: showPrevButton, showNextButton: showNextButton });
        };
        _this.scrollSlider = function (_a) {
            var left = _a.left, _b = _a.top, top = _b === void 0 ? 0 : _b, _c = _a.behavior, behavior = _c === void 0 ? "smooth" : _c;
            window.requestAnimationFrame(function () {
                var _a;
                (_a = _this.slidesRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ left: left, top: top, behavior: behavior });
            });
        };
        _this.setContentOverflow = function () {
            requestAnimationFrame(function () {
                if (!_this.gridRef.current)
                    return;
                var totalWidthOfSliderChildren = Array.from(_this.gridRef.current.childNodes);
                var width = totalWidthOfSliderChildren.reduce(function (width, child) { return width + child.getBoundingClientRect().width; }, 0);
                var slideContentIsOverflowingContainer = width > window.innerWidth;
                _this.setState({
                    slideContentIsOverflowingContainer: slideContentIsOverflowingContainer,
                    totalWidthOfSliderChildren: width
                });
            });
        };
        _this.getCurrentIndex = function () {
            var _a, _b;
            var containerOffsetLeft = ((_a = _this.containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) || 0;
            var domSlides = Array.from(((_b = _this.gridRef.current) === null || _b === void 0 ? void 0 : _b.childNodes) || []);
            var currentIndex = domSlides.findIndex(function (slide) {
                return Math.round(slide.getBoundingClientRect().right - containerOffsetLeft) >
                    0;
            });
            return currentIndex;
        };
        return _this;
    }
    HeroSlider.prototype.render = function () {
        var _this = this;
        var _a = this.props, mapboxApiToken = _a.mapboxApiToken, latitude = _a.latitude, longitude = _a.longitude, zoomLevel = _a.zoomLevel, subjectPropertyPin = _a.subjectPropertyPin, mapOptions = _a.mapOptions, onMapClick = _a.onMapClick;
        var _b = this.state, showPrevButton = _b.showPrevButton, showNextButton = _b.showNextButton, totalWidthOfSliderChildren = _b.totalWidthOfSliderChildren, allImagesHaveLoaded = _b.allImagesHaveLoaded;
        var remainingSpace = window.innerWidth - totalWidthOfSliderChildren;
        var staticMapWidth = 398;
        var mapWidth = allImagesHaveLoaded
            ? remainingSpace < staticMapWidth
                ? staticMapWidth
                : remainingSpace
            : staticMapWidth;
        return (React.createElement(Container, { ref: this.containerRef, tabIndex: 0, onKeyDown: this.handleOnKeyDown, onMouseUp: this.handleOnMouseUp, onScroll: this.handleOnScroll },
            React.createElement(Slides, { ref: this.slidesRef },
                React.createElement(Grid, { ref: this.gridRef },
                    React.createElement(MapContainer, { style: { width: mapWidth } }, allImagesHaveLoaded && (React.createElement(ListingMapStatic, __assign({ mapboxApiToken: mapboxApiToken, latitude: latitude, longitude: longitude, zoomLevel: zoomLevel, width: mapWidth, height: 275, pin: subjectPropertyPin }, mapOptions, { onClick: onMapClick })))),
                    Children.map(this.props.children, function (child) {
                        var el = child;
                        var styledEl = child;
                        var isImage = el.type === "img" || styledEl.type.target === "img";
                        return (React.createElement(HeroSlide, null, cloneElement(el, __assign(__assign({}, (isImage && {
                            onLoad: _this.handleImgLoad,
                            onError: _this.handleImgLoad
                        })), { style: __assign(__assign({}, el.props.style), { height: "100%" }) }))));
                    }))),
            showPrevButton && React.createElement(HeroSliderPrev, { onClick: this.handleOnPrev }),
            showNextButton && React.createElement(HeroSliderNext, { onClick: this.handleOnNext })));
    };
    HeroSlider.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.setContentOverflow);
        this.setContentOverflow();
    };
    HeroSlider.prototype.componentDidUpdate = function (_, prevState) {
        var allImagesHaveLoaded = this.state.allImagesHaveLoaded;
        var numberOfimageLoadedCountHasChanged = prevState.imageLoadedCount !== this.state.imageLoadedCount;
        if (numberOfimageLoadedCountHasChanged && allImagesHaveLoaded) {
            this.setContentOverflow();
        }
        if (this.state.slideContentIsOverflowingContainer !==
            prevState.slideContentIsOverflowingContainer) {
            this.props.onContentOverflow(this.state.slideContentIsOverflowingContainer);
            this.toggleButtons();
        }
    };
    HeroSlider.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.setContentOverflow);
    };
    HeroSlider.defaultProps = {
        mapOptions: {},
        zoomLevel: 15
    };
    return HeroSlider;
}(Component));
export default HeroSlider;
